'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    save: 'Сохранить',
    send: 'Отправить',
    next: 'Вперед',
    prev: 'Назад',
    required: 'Это поле обязательно для заполнения',
    month: 'Месяц',
    monthYearError: 'Месяц и год обязательны для заполнения',
    yearError: 'Год обязателен для заполнения',
    monthError: 'Месяц обязателен для заполнения',
    dayError: 'День обязателен для заполнения',
    dayYearError: 'День и год обязательны для заполнения',
    dayMonthError: 'День и месяц обязательны для заполнения',
    add: 'Добавить',
    delete: 'Удалить',
    cancel: 'Отмена',
    selectDate: 'Выбрать дату',
    selectMonth: 'Выберите месяц',
    minLength: '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D, \u043F\u043E\u0442\u043E\u043C\u0443 \u0447\u0442\u043E \u043D\u0435 \u0432\u0432\u0435\u0434\u0435\u043D\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u043D\u0430\u043A\u043E\u0432!\n\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u043D\u0430\u043A\u043E\u0432: {minLength}\n\u0417\u043D\u0430\u043A\u043E\u0432 \u0432\u0432\u0435\u0434\u0435\u043D\u043E: {length}'
};